
/** 典当类 */
export namespace PawnKind {

    /** 通用数值 */  
    export enum GeneralValue {
        /** 每日减少好感 */
        EVERY_DAY_SUB_GOOD = -30,
        /** 广告增加好感 */
        AD_ADD_GOOD = 100,
        /** 每日限制广告次数 */
        EVERY_DAY_AD_COUNT_LIMIT = 1,
    }

}